import styled from 'styled-components'

import { DEFECT_FALLBACK_PRIORITY, DEFECT_PRIORITIES } from './constants'

import { useLocale } from '@/context/localeContext'

import { DefectPriority as DefectpriorityEnum } from 'types/api.graphql'

const PriorityLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`

const PriorityIcon = styled.span`
  display: inline-flex;
  align-items: center;
`

type PriorityProps = {
  priority: DefectpriorityEnum
  className?: string
}

export const DefectPriority: React.FC<PriorityProps> = ({
  priority,
  className,
}) => {
  const { t } = useLocale()
  const priorityConfig = DEFECT_PRIORITIES[priority] || DEFECT_FALLBACK_PRIORITY

  if (!priorityConfig) return null

  return (
    <PriorityLabel
      style={{ color: priorityConfig.colour }}
      className={className}
    >
      <PriorityIcon style={{ color: priorityConfig.colour }}>
        {priorityConfig.icon}
      </PriorityIcon>
      {t(priorityConfig.labelPath)}
    </PriorityLabel>
  )
}
